import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import { Key, ArrowLeft } from 'lucide-react'

export function PrivacyPolicy() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Twenty</title>
        <meta name="description" content="How we handle your data at Twenty. Simple, transparent privacy practices." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      
      <div className="min-h-screen bg-background">
        <nav className="border-b border-border">
          <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2">
              <Key className="w-5 h-5 text-primary" />
              <span className="font-semibold">Twenty</span>
            </Link>
            <Link to="/" className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1">
              <ArrowLeft className="w-4 h-4" />
              Back
            </Link>
          </div>
        </nav>

        <main className="max-w-4xl mx-auto px-6 py-12">
          <h1 className="text-3xl font-semibold mb-8">Privacy Policy</h1>
          
          <div className="prose prose-neutral max-w-none">
            <p className="text-muted-foreground mb-6">Last updated: {new Date().toLocaleDateString()}</p>

            <section className="mb-8">
              <h2 className="text-xl font-medium mb-4">What We Collect</h2>
              <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
                <li>Email address (for account creation)</li>
                <li>API usage data (requests, timestamps, endpoints)</li>
                <li>Billing information (handled by Stripe)</li>
                <li>Secrets you store (encrypted, we cannot read them)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-medium mb-4">What We Don't Collect</h2>
              <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
                <li>Content of your API requests (passed through, not stored)</li>
                <li>Personal data beyond what's needed for service</li>
                <li>Tracking cookies or analytics</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-medium mb-4">How We Use Data</h2>
              <p className="text-muted-foreground mb-4">
                We use your data solely to provide and improve the service:
              </p>
              <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
                <li>Authentication and account management</li>
                <li>Usage metering and billing</li>
                <li>Service monitoring and debugging</li>
                <li>Security and abuse prevention</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-medium mb-4">Data Storage</h2>
              <p className="text-muted-foreground">
                Data is stored across multiple infrastructure providers including Railway, 
                PlanetScale, AWS, GCP, Azure, Cloudflare, and other third-party services. 
                Secrets are encrypted with AES-256-GCM before storage. API keys are hashed 
                and cannot be retrieved once created.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-medium mb-4">Third Parties</h2>
              <p className="text-muted-foreground">
                We use Stripe for billing and various cloud providers for infrastructure. 
                We do not sell or share your data with any other third parties.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-medium mb-4">Contact</h2>
              <p className="text-muted-foreground">
                Questions? Email us at privacy@twenty.sh
              </p>
            </section>
          </div>
        </main>

        <footer className="border-t border-border py-8">
          <div className="max-w-4xl mx-auto px-6">
            <p className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} Twenty
            </p>
          </div>
        </footer>
      </div>
    </>
  )
}
